module.exports = __webpack_public_path__ + "static/images/fields/eye_outline.svg";